module.exports = __webpack_public_path__ + "img/smg03_samurai02skin_shop.fc0ebb15.png";